import React,{ useState } from "react";
import UserNavbar from "./UserNavbar";
import "../../css/whatsapp.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { getSupportNumber } from "../../services/user-service";

const UserBase = ({ title = "Welcome to our website", children }) => {
    const [showWhatsApp, setShowWhatsApp] = useState(false);
    const handleWhatsApp = () => {

        getSupportNumber()
            .then((response) => {

                const supportNumber = response.data;

                window.open(
                    `https://wa.me/${supportNumber}?text=Hello%20iChest%20Support`,
                    "_blank"
                );

            })
            .catch((err) => {

                console.log(err);

                alert("Unable to open WhatsApp.");

            });

    };
  return (
    <div className="container-fluid p-0 m-0">
      <UserNavbar />
      {children}
        {/* WhatsApp Floating Button */}
        <div className="whatsapp-widget">

            {!showWhatsApp && (
                <div
                    className="whatsapp-circle"
                    onClick={() => setShowWhatsApp(true)}
                >
                    <FontAwesomeIcon
                        icon={faWhatsapp}
                        className="whatsapp-circle-icon"
                    />
                </div>
            )}

            {showWhatsApp && (
                <div className="whatsapp-card">

                    <div className="whatsapp-header">
                        <span>Need Help?</span>

                        <button
                            className="close-btn"
                            onClick={() => setShowWhatsApp(false)}
                        >
                            ×
                        </button>
                    </div>

                    <p className="whatsapp-text">
                        Chat with iChest Support
                    </p>

                    <button
                        className="whatsapp-btn"
                        onClick={handleWhatsApp}
                    >
                        <FontAwesomeIcon
                            icon={faWhatsapp}
                            className="whatsapp-icon"
                        />

                        <span>Chat on WhatsApp</span>
                    </button>

                </div>
            )}

        </div>
 
    </div>
  );
};
export default UserBase;
